export default {"src":"/_next/static/media/plus.be3109a9.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};